define.alias("ember-math-helpers/helpers/gcd", "calendar/helpers/gcd");